
<template>
    <b-container fluid class="general-wrapper">
        <h1 class="header-title">General Cardiology Section</h1>
        <v-divider></v-divider>
        <div class="data-wrapper">
            <table v-for="item in sortedGeneralContent" :key="item.id">
                    <tbody >
                        <div class="anchor" v-bind:id="item.shortcut"/>
                        <tr >
                            <td class="title">
                                {{item.name}}
                            </td>
                        </tr>
                        <tr>
                            <td class='time-stamp'>
                                Last updated: {{item.updated_at.seconds*1000|moment("MM-DD-YY")}}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div v-html="item.data" ></div>
                            </td>
                        </tr>
                    </tbody>
                </table>
        </div>
    </b-container>
</template>

<script src="https://cdn.jsdelivr.net/lodash/4.13.1/lodash.js"></script>

<script>

import {mapGetters} from 'vuex'  
import {analytics} from "../../firebase";
analytics.logEvent("General Cardiology");

export default {
    name: 'general',
    computed: {
            ...mapGetters([
                'getGeneralContent',
            ]),
            sortedGeneralContent: function () {
                return _.orderBy(this.getGeneralContent, 'order')
            },
        },
        options: {
            linkAttribute: {
                target: '_self',
           
    }
},
            mounted() {
                this.$ga.page('/general');
            }
}
</script>

<style>


    ol,ul{
        list-style: square;
    }

   p:empty {
    display: none;
    }

 
    p{
        margin-bottom: 3px;
        margin-top: 10px;
    }

    br{
        display:none;
    }

    img {
    max-width: 800px;
    max-height: 1200px;   
    margin-left: 2em;
    margin-right: auto;
    height: auto;
    padding-top: 10px; 
} 

    .anchor{
        margin-top: -40px;
    }

    .ql-indent-1 {
    list-style-type: circle;
    margin-left: 1em;
    margin-top: 1px;
    margin-bottom: 3px;
    }

    .ql-indent-2{
        list-style-type: disc;
        margin-left: 2em;
        margin-top: 1px;
        margin-bottom: 3px;
    }
   
    .time-stamp{
        font-style: italic;
        padding-bottom: 10px;
        color:gray;
    }
    .header-title{
        font-size: 2em;
        font-weight: 900;
        padding-top:20px;
    }
    .general-wrapper{
        width: 100vw;
        padding-right: 25px;
        padding-left: 30vw;
        
    }

    div{
        width: 65vw;
    }

    .data-wrapper {
        text-align: left;
        margin-right: 10vw;
    }

    .title{
        padding-top: 10px;
        font-size: 1.5em;
        font-weight: bold;
        color: #c10e21;

    }

    @media screen and (max-width: 991px){
          .general-wrapper {
            width: 100vw;
            padding-top: 40px;
            padding-left: 5px;
            padding-right: 5px;
      }

        div{
            width: 85vw;
        }
      .data-wrapper{
          margin-right: 5vw;
          margin-left: 5vw;
      }
      img{
          max-width: 80vw;
          height: auto;
          align-items: center;
          margin-left:0px;
      }
    
        ol, ul {
        list-style: square;
        padding-left: 3px;
    }
    
        table{
            max-width: 365px;
            padding-right: 5px;
        }
        span{
            margin-right: 5px;
        }
        p{
            margin-right: 5px;
        }
        div{
            max-width: 100vw;
        }
    
      
    }

</style>